import { useParams, Navigate } from 'react-router-dom';
import RoadPermitApplicationList from 'src/pages/Permits/RoadPermit/ApplicationList';
import TreePermitApplicationList from 'src/pages/Permits/TreePermit/ApplicationList';
import PlanningAndZoningApplicationList from 'src/pages/Permits/PlanningAndZoningPermit/ApplicationList';
import SolicitorApplicationList from 'src/pages/Permits/Solicitor/ApplicationList';
import CharitableSolicitationsApplicationList from 'src/pages/Permits/CharitableSolicitationsPermit/ApplicationList';
import UsedCarDealerApplicationList from 'src/pages/Permits/UsedCarDealer/ApplicationList';
import VendingApplicationList from 'src/pages/Permits/ClerkVending/VeningAllApplications';
import ConstructionApplicationList from 'src/pages/Permits/Construction/ApplicationList';
import PetApplicationList from 'src/pages/Permits/PetPermit/ApplicationList';
import FoodApplicationList from 'src/pages/Permits/Food&BeverageLicenseManagment/ApplicationList';

const ApplicationListRedirectHandler = () => {
  const { department, permit } = useParams();

  if (department === 'Engineering Department' && permit === '2') {
    return <RoadPermitApplicationList />;
  } else if (department === 'Engineering Department' && permit === '4') {
    return <TreePermitApplicationList />;
  } else if (department === 'Planning Department' && permit === '1') {
    return <PlanningAndZoningApplicationList />;
  } else if (department === 'Clerk Department' && permit === '6') {
    return <SolicitorApplicationList />;
  } else if (department === 'Clerk Department' && permit === '5') {
    return <CharitableSolicitationsApplicationList />;
  } else if (department === 'Clerk Department' && permit === '7') {
    return <UsedCarDealerApplicationList />;
  } else if (department === 'Clerk Department' && permit === '8') {
    return <VendingApplicationList />;
  } else if (department === 'Building or Construction Department' && permit === '9') {
    return <ConstructionApplicationList />;
  } else if (department === 'Department of Health or Animal Control' && permit === '10') {
    return <PetApplicationList />;
  }
  else if (department === 'Department of Health and Mental Hygiene' && permit === '12') {
    return <FoodApplicationList />;
  }

  return <Navigate to="/unauthorized" />;
};

export default ApplicationListRedirectHandler;
